import styled from 'styled-components'

export const Container = styled.main`
  max-width: 62.5rem;
  padding: 2%;
  margin: auto;

  > :last-child {
    background: black;
    border-radius: 0.5rem;
    padding: 1rem;
    margin-top: 1rem;
  }
`
